/**
 * Tiny pub-sub for the global "we're logging out, show the overlay"
 * signal. The provider (``authenticator-provider.js``) registers its
 * ``setIsLoggingOut`` setter at mount; logout call sites (or the
 * ``runPreLogout`` helper) call ``signalLogoutStarted`` to flip the
 * overlay on as soon as the user clicks logout — long before
 * ``Auth.signOut`` resolves and the page redirects.
 *
 * Kept in module scope (not React state) because logout is triggered
 * from non-React paths too (errorBoundry, layoutHelpers, gatsby
 * navigation flows). The provider gates on the registered setter so
 * SSR / first-render calls before mount are safe no-ops.
 */

let overlaySetter = null;
// Module-scoped mirror of the React `isLoggingOut` state so non-React
// callers (the Apollo link in particular) can synchronously check
// whether a logout flow is in progress and short-circuit outgoing
// requests instead of firing them at a token that's about to be wiped.
let loggingOut = false;

export const registerLogoutOverlaySetter = setter => {
  overlaySetter = setter;
};

export const signalLogoutStarted = () => {
  loggingOut = true;
  if (typeof overlaySetter === "function") {
    overlaySetter(true);
  }
};

export const signalLogoutEnded = () => {
  loggingOut = false;
  if (typeof overlaySetter === "function") {
    overlaySetter(false);
  }
};

export const isLogoutInProgress = () => loggingOut;
